<template>
  <div class="input-group">
    <span class="input-group-btn">
      <button type="button" class="btn btn-default btn-number"
          @click="decrement()"
          :disabled="$attrs.disabled">
        <span class="glyphicon glyphicon-minus"></span>
      </button>
    </span>
    <input class="form-control" type="text" pattern="[0-9]*"
      v-bind="$attrs"
      :value="value"
      @input="updateValue"
      @blur="updateValueWithBoundaries"
      number required>
    <span class="input-group-btn">
      <button type="button" class="btn btn-default btn-number"
          @click="increment()"
          :disabled="$attrs.disabled">
        <span class="glyphicon glyphicon-plus"></span>
      </button>
    </span>
  </div>
</template>

<script>
// Number input component
// Only accepts numbers as value
// Includes + and - buttons

export default {
  inheritAttrs: false,
  props: ['value', 'min-value', 'max-value', 'increment-by'],
  methods: {
    increment: function () {
      if (this.value + this.incr <= Number(this.maxValue)) {
        this.$emit('input', this.value + this.incr)
      }
    },
    decrement: function () {
      if (this.value - this.incr >= Number(this.minValue)) {
        this.$emit('input', this.value - this.incr)
      }
    },
    updateValue: function (event) {
      var validatedValue = this.validate(event.target.value)
      event.target.value = validatedValue
      this.$emit('input', validatedValue)
    },
    updateValueWithBoundaries: function (event) {
      var validatedValue = this.validateBounds(event.target.value)
      event.target.value = validatedValue
      this.$emit('input', validatedValue)
    },
    validate: function (inputValue) {
      var newValue = Number(inputValue.replace(/\D/g, ''))
      if (!isNaN(newValue)) {
        return newValue
      }
    },
    validateBounds: function (inputValue) {
      var newValue = Number(inputValue.replace(/\D/g, ''))
      if (isNaN(newValue) || newValue < Number(this.minValue)) {
        return Number(this.minValue)
      } else if (newValue > Number(this.maxValue)) {
        return Number(this.maxValue)
      } else {
        return newValue
      }
    }
  },
  computed: {
    incr: function () {
      return Number(this.incrementBy)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InputNumber.vue?3cbc65aa